import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const RequireAuth = () => {
  const { authenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth">
        <div className="auth-container">
          <div className="login-logo">
          </div>
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  if (!authenticated) {
    // Check if this is a password reset callback
    const searchParams = new URLSearchParams(location.search);
    const resetKey = searchParams.get("resetKey");
    const email = searchParams.get("email");

    if (resetKey && email) {
      // Redirect to change password page with query params
      return (
        <Navigate
          to={`/login/change-password?resetKey=${resetKey}&email=${email}`}
          replace
        />
      );
    }

    // Store the attempted location for redirect after login
    localStorage.setItem(
      "postLoginRedirect",
      location.pathname + location.search
    );
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
